document.addEventListener("DOMContentLoaded", function() {
    const accordions = document.querySelectorAll(".product-collapsible-widget");

    const openAccordion = (accordion) => {
        const content = accordion.querySelector(".product-collapsible-widget__content");
        accordion.classList.add("open");
        content.style.maxHeight = content.scrollHeight + "px";
    };

    const closeAccordion = (accordion) => {
        const content = accordion.querySelector(".product-collapsible-widget__content");
        accordion.classList.remove("open");
        content.style.maxHeight = null;
    };

    accordions.forEach((accordion) => {
        const intro = accordion.querySelector(".product-collapsible-widget__header");
        const content = accordion.querySelector(".product-collapsible-widget__content");

        intro.onclick = () => {
            if (content.style.maxHeight) {
                closeAccordion(accordion);
            } else {
                accordions.forEach((accordion) => closeAccordion(accordion));
                openAccordion(accordion);
            }
        };
    });

 // IMAGE ZOOM
if (window.innerWidth > 768) {
  var paneContainer = document.querySelector('.product-page__content');

  function initDriftZoom() {
    document.querySelectorAll('.mobile-zoom-wrapper').forEach(wrapper => {
      const img = wrapper.querySelector('img');

      if (!img) return;

      if (!img.getAttribute('data-zoom')) {
        img.setAttribute('data-zoom', img.getAttribute('src'));
      }

      if (!img.classList.contains('drift-zoomed')) {
        new Drift(img, {
          inlinePane: true,
          containInline: true,
          inlinePane: 768,
          zoomFactor: 2
        });

        img.classList.add('drift-zoomed');
      }
    });
  }

  const observer = new MutationObserver(() => {
    const zoomEls = document.querySelectorAll(
      '.mobile-zoom-wrapper img:not(.drift-zoomed)'
    );

    if (zoomEls.length > 0) {
      initDriftZoom();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  setTimeout(initDriftZoom, 1000);
}
  // IMAGE POPUP
    const mediaEls = document.querySelectorAll('.product__media');

  if (!mediaEls.length) return;

  const galleryItems = [];

  mediaEls.forEach((mediaEl, index) => {
    const imgProduct = mediaEl.querySelector('img');
    if (!imgProduct) return;

    const src = imgProduct.getAttribute('src');
    if (!src) return;

   
    galleryItems.push({
      src: src,
      type: 'image'
    });

   
    mediaEl.addEventListener('click', function () {
      Fancybox.show(galleryItems, {
        startIndex: index,
        Thumbs: false,
        Toolbar: {
          display: ["close"]
        }
      });
    });
  });

  if (window.innerWidth > 768) {
    const element = document.querySelector('.product-page__virtual-try-mobile');
    const newContainer = document.querySelector('.product-page__images-wrap');

    if (element && newContainer) {
      newContainer.appendChild(element); 
    }
    element.style.marginTop = '90px';
  }
  document.querySelectorAll('[data-product-video]').forEach((wrapper) => {
  const thumbnail = wrapper.querySelector('[data-video-thumbnail]');
  const video = wrapper.querySelector('video');
  const youtube = wrapper.querySelector('.product-video-youtube');

  if (!thumbnail) return;

  thumbnail.addEventListener('click', () => {
    thumbnail.style.display = 'none';

    if (video) {
      video.classList.remove('hidden');
      video.play();
    }

    if (youtube) {
      youtube.classList.remove('hidden');

      const iframe = youtube.querySelector('iframe');

      if (iframe) {
        const separator = iframe.src.includes('?') ? '&' : '?';
        iframe.src += `${separator}autoplay=1`;
      }
    }
  });
});
});

